import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { clinicAPI, authAPI } from '../services/api'
import './PatientDetailPage.css'

function PatientDetailPage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [patient, setPatient] = useState(null)
  const [analysis, setAnalysis] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  
  useEffect(() => {
    authAPI.checkAuth().then(isAuth => {
      if (!isAuth) {
        navigate('/login')
        return
      }
      
      const clinicId = parseInt(localStorage.getItem('clinic_id'))
      if (!clinicId) {
        setError('Brak wybranej przychodni.')
        setLoading(false)
        return
      }
      
      loadPatientData(id, clinicId)
    }).catch(err => {
      console.error('Auth check error:', err)
      navigate('/login')
    })
  }, [id, navigate])
  
  const loadPatientData = async (submissionId, clinicId) => {
    try {
      setLoading(true)
      setError('')
      const data = await clinicAPI.viewPatient(submissionId, clinicId)
      setPatient(data.submission)
      setAnalysis(data.genogram_analysis)
    } catch (err) {
      const errorMsg = err.response?.data?.error || err.message || 'Błąd ładowania danych pacjenta.'
      setError(errorMsg)
      console.error('Error loading patient:', err)
    } finally {
      setLoading(false)
    }
  }
  
  if (loading) {
    return <div className="patient-detail-page">Ładowanie...</div>
  }
  
  if (error) {
    return <div className="patient-detail-page"><div className="error-message">{error}</div></div>
  }
  
  return (
    <div className="patient-detail-page">
      <header className="detail-header">
        <button onClick={() => navigate('/dashboard')} className="btn-back">
          ← Powrót
        </button>
        <h1>Szczegóły Pacjenta</h1>
      </header>
      
      <main className="detail-main">
        {patient && (
          <section className="patient-section">
            <h2>Dane Personalne</h2>
            <div className="info-grid">
              <div className="info-item">
                <label>Imię:</label>
                <span>{patient.personal_info?.name || '-'}</span>
              </div>
              <div className="info-item">
                <label>Nazwisko:</label>
                <span>{patient.personal_info?.surname || '-'}</span>
              </div>
              <div className="info-item">
                <label>PESEL:</label>
                <span>{patient.personal_info?.pesel || '-'}</span>
              </div>
              <div className="info-item">
                <label>Email:</label>
                <span>{patient.personal_info?.email || '-'}</span>
              </div>
              <div className="info-item">
                <label>Status:</label>
                <span>{patient.status}</span>
              </div>
              <div className="info-item">
                <label>Data utworzenia:</label>
                <span>{new Date(patient.created_at * 1000).toLocaleDateString('pl-PL')}</span>
              </div>
            </div>
          </section>
        )}
        
        {analysis && (
          <section className="analysis-section">
            <h2>Analiza Genogramu</h2>
            
            {analysis.error ? (
              <div className="error-message">Błąd: {analysis.error}</div>
            ) : (
              <>
                <div className="analysis-summary">
                  <p><strong>Nazwa:</strong> {analysis.genogram_name || '-'}</p>
                  <p><strong>Dopasowane rozpoznania:</strong> {analysis.matched_count || 0} / {analysis.total_diagnoses || 0}</p>
                </div>
                
                {analysis.matched_diagnoses && analysis.matched_diagnoses.length > 0 ? (
                  <div className="diagnoses-list">
                    <h3>Dopasowane Rozpoznania ({analysis.matched_diagnoses.length})</h3>
                    {analysis.matched_diagnoses.map((diag, idx) => (
                      <div key={idx} className="diagnosis-card">
                        <h4>
                          {diag.diagnosis_name}
                          {diag.diagnosis_acronym && ` (${diag.diagnosis_acronym})`}
                        </h4>
                        <p><strong>Kryteria:</strong> {diag.required_count || '-'} przypadków w odległości do {diag.max_distance || '-'}</p>
                        <p><strong>Dopasowane przypadki:</strong> {diag.matched_cases?.length || 0}</p>
                        {diag.recommendation && (
                          <div className="recommendation-section">
                            <h5>Rekomendacje:</h5>
                            {diag.recommendation.rekomendacje_self && (
                              <p><strong>Dla siebie:</strong> {diag.recommendation.rekomendacje_self}</p>
                            )}
                            {diag.recommendation.rekomendacje_family && (
                              <p><strong>Dla rodziny:</strong> {diag.recommendation.rekomendacje_family}</p>
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="empty-state">Brak dopasowanych rozpoznań</p>
                )}
              </>
            )}
          </section>
        )}
      </main>
    </div>
  )
}

export default PatientDetailPage
